import { FormType } from '../../../form-types';
import { EnclomipheneQuestionFieldAnswers } from '../questions';

const enclomipheneFollowup: FormType<EnclomipheneQuestionFieldAnswers> = {
  name: 'Testosterone Support Follow-up',
  questions: [
    {
      key: 'enclomipheneFollowup_sexAssignedAtBirth',
      next: {
        condition: {
          'enclomipheneFollowup_sexAssignedAtBirth.male': true
        },
        key: 'enclomipheneFollowup_height',
        els: 'enclomipheneFollowup_ineligible'
      }
    },
    'enclomipheneFollowup_height',
    'enclomipheneFollowup_weight',
    {
      key: 'enclomipheneFollowup_healthChanges',
      next: {
        condition: {
          'enclomipheneFollowup_healthChanges.yes': true
        },
        key: 'enclomipheneFollowup_healthChangesDetails',
        els: 'enclomipheneFollowup_medicationDoing'
      }
    },
    'enclomipheneFollowup_healthChangesDetails',
    {
      key: 'enclomipheneFollowup_medicationDoing',
      next: {
        condition: {
          'enclomipheneFollowup_medicationDoing.not_well': true
        },
        key: 'enclomipheneFollowup_medicationExperience',
        els: 'enclomipheneFollowup_sideEffects'
      }
    },
    'enclomipheneFollowup_medicationExperience',
    {
      key: 'enclomipheneFollowup_sideEffects',
      next: {
        condition: {
          'enclomipheneFollowup_sideEffects.yes': true
        },
        key: 'enclomipheneFollowup_sideEffectsDetails',
        els: 'enclomipheneFollowup_continueTreatment'
      }
    },
    'enclomipheneFollowup_sideEffectsDetails',
    'enclomipheneFollowup_continueTreatment',
    'enclomipheneFollowup_additionalQuestions',
    {
      key: 'enclomipheneFollowup_consentTreatment',
      next: {
        condition: {
          'enclomipheneFollowup_consentTreatment.non_consent': true
        },
        key: 'enclomipheneFollowup_ineligible',
        els: 'enclomipheneFollowup_complete'
      }
    },
    'enclomipheneFollowup_complete',
    'enclomipheneFollowup_ineligible'
  ]
};

export default enclomipheneFollowup;
